var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.879 0C9.33699 0.0654087 0 9.44253 0 21.0002C0 32.598 9.4024 42 20.9998 42C32.598 42 42 32.598 42 21.0002C42 9.44253 32.6634 0.0654087 21.121 0H20.879Z",
  fill: "#8973D5"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_392_2556",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 42,
  height: 42
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.879 0C9.33699 0.0654087 0 9.44253 0 21.0002C0 32.598 9.4024 42 20.9998 42C32.598 42 42 32.598 42 21.0002C42 9.44253 32.6634 0.0654087 21.121 0H20.879Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_392_2556)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1562 31.8159H25.1987V26.397H17.1562V31.8159Z",
  fill: "#F9BB9F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5731 16.3625C29.5988 16.1659 29.9254 15.8449 30.0687 15.7369C30.3873 15.4958 30.7083 15.7438 30.8014 16.0576C30.8849 16.3385 30.8925 16.6547 30.9125 16.9464C30.9611 17.6567 30.856 18.3545 30.543 18.9957C30.3347 19.4231 30.0073 19.7746 29.62 20.0399C29.62 20.0399 29.2027 20.2525 29.1196 19.7638C29.1196 19.7638 29.5727 16.3645 29.5731 16.3625Z",
  fill: "#F9BB9F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5069 16.7893C29.5253 16.6484 29.7593 16.4193 29.8612 16.3414C30.0895 16.1689 30.3194 16.3463 30.3861 16.571C30.4454 16.7724 30.4515 16.9983 30.4655 17.207C30.5004 17.7154 30.4254 18.2146 30.2011 18.6733C30.0518 18.9795 29.8178 19.2311 29.541 19.4213C29.541 19.4213 29.242 19.573 29.1826 19.2234C29.1826 19.2234 29.5069 16.7913 29.5069 16.7893Z",
  fill: "#DCA68E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5768 16.3625C12.5503 16.1659 12.2236 15.8449 12.0808 15.7369C11.7622 15.4958 11.4411 15.7438 11.3476 16.0576C11.2646 16.3385 11.2569 16.6547 11.2369 16.9464C11.1883 17.6567 11.2935 18.3545 11.6065 18.9957C11.8151 19.4231 12.1422 19.7746 12.5298 20.0399C12.5298 20.0399 12.9467 20.2525 13.0302 19.7638C13.0302 19.7638 12.5772 16.3645 12.5768 16.3625Z",
  fill: "#F9BB9F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6433 16.7893C12.6249 16.6484 12.3909 16.4193 12.2886 16.3414C12.0603 16.1689 11.8307 16.3463 11.7641 16.571C11.7047 16.7724 11.6991 16.9983 11.6851 17.207C11.6497 17.7154 11.7252 18.2146 11.9491 18.6733C12.0984 18.9795 12.3323 19.2311 12.6096 19.4213C12.6096 19.4213 12.9086 19.573 12.9679 19.2234C12.9679 19.2234 12.6437 16.7913 12.6433 16.7893Z",
  fill: "#DCA68E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.8274 17.0026C29.8274 19.245 29.4494 21.5126 28.4165 23.4532C27.5132 25.1506 26.1581 26.5094 24.7034 27.5948C23.5241 28.4756 22.2584 29.5013 20.7649 29.3761C19.2079 29.2453 17.9956 27.887 16.858 26.8268C15.2585 25.336 13.9961 23.4845 13.218 21.306C12.7393 19.9637 12.5186 18.4481 12.5186 17.0026C12.5186 9.75311 16.3929 5.19296 21.173 5.19296C25.953 5.19296 29.8274 9.75311 29.8274 17.0026Z",
  fill: "#F9BB9F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.2207 34.2659L25.1984 31.6456H21.1771H17.1559L7.13312 34.2659C7.13312 34.2659 2.4887 35.9866 1.97266 41.434H21.1771H40.3816C39.8656 35.9866 35.2207 34.2659 35.2207 34.2659Z",
  fill: "#F9BB9F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.2207 34.2659L25.1984 31.6456H21.1771H17.1559L7.13312 34.2659C7.13312 34.2659 2.4887 35.9866 1.97266 41.434H21.1771H40.3816C39.8656 35.9866 35.2207 34.2659 35.2207 34.2659Z",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.2207 34.2659L27.8035 32.3266L21.1771 41.434L14.6222 32.3077L7.13312 34.2659C7.13312 34.2659 2.4887 35.9866 1.97266 41.434H21.1771H40.3816C39.8656 35.9866 35.2207 34.2659 35.2207 34.2659Z",
  fill: "#164748"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2979 36.8711L18.4512 41.4341H23.6979L21.8982 36.8711H20.2979Z",
  fill: "#EB524F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.0563 31.7348L18.7056 34.8877L20.3392 36.8837L21.1397 36.8708L21.9395 36.8576L23.5077 34.8102L21.0563 31.7348Z",
  fill: "#EB524F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.1775 41.4341L14.6226 32.3078L9.38184 33.6786L16.0792 38.394L14.3589 39.1525L17.4552 41.4341H21.1775Z",
  fill: "#003434"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.1768 41.4467L27.7313 32.3207L32.9728 33.6911L26.275 38.4062L27.9953 39.165L24.899 41.4467H21.1768Z",
  fill: "#003434"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2114 31.8375L17.142 29.9932L21.1496 31.6669L25.1571 29.9932L29.3569 31.8375L23.4184 35.813L21.1496 32.563L18.705 35.813L13.2114 31.8375Z",
  fill: "#E1E2E3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.243 26.2846C26.243 26.2846 28.416 24.2297 28.8959 22.4159C28.8959 22.4159 26.3321 24.7289 25.4385 24.4833L26.243 26.2846Z",
  fill: "#140100"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.714 26.899C16.714 26.899 14.1951 24.741 13.5029 22.0367C13.5029 22.0367 16.3765 25.3541 17.2701 25.1073L16.714 26.899Z",
  fill: "#140100"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7088 23.3412C24.1313 23.3605 24.907 23.8517 24.907 23.8517C26.1562 24.4408 26.4752 26.0431 26.4752 26.0431C26.4752 26.0431 25.6156 26.9945 24.5663 27.6675C22.1951 29.6329 21.1072 29.3845 21.1072 29.3845C19.7581 29.3861 18.8115 28.5422 18.8115 28.5422L16.5924 26.8039C16.3164 24.8276 18.0403 23.8517 18.0403 23.8517C19.074 23.3497 19.261 23.4163 19.261 23.4163C19.261 23.4163 20.8099 23.2357 21.1887 23.8509C21.1887 23.8509 21.5784 23.3412 22.6317 23.3412",
  fill: "#1C0500"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3846 24.9671C21.3846 24.9671 20.4111 24.4803 18.9941 25.0032C18.9941 25.0032 21.1446 27.2837 23.586 25.0333C23.586 25.0333 22.2778 24.4226 21.3846 24.9671Z",
  fill: "#F9BB9F"
}))));
export default __webpack_public_path__ + "static/media/icon_avatar.b407ff59.svg";
export { SvgIconAvatar as ReactComponent };